import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { InitStatus, SOTService } from "../../services";


@Component({
  selector: "sot-preloaded-images",
  template: `<img *ngFor="let image of images" class="ya_image" [src]="image">`,
  styles: [`:host { display:none; }`],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class SOTPreLoadImages implements OnInit {
  public images: string[] = [];

  constructor(
    private _sotService: SOTService,
    private _changeDetectorRef: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    const me = this;
    me._sotService.evInitalisationStatusChanged.subscribe(() => {
      if (me._sotService.initalisation_status === InitStatus.done) {
        const advertisementImages = me._sotService.GetAdvertisments().filter(i => i.has_image).map(i => i.image_path);
        const startPageMedia = me._sotService.GetStartpages().filter(i => i.has_media).map(i => i.media_path);
        const costumLogoImages = me._sotService.GetSettings().logo_image_path;
        const paymentLogoImages = me._sotService.GetSettings().payment_image_path;
        const productImages = me._sotService.GetAllProducts().filter(i => i.has_image).map(i => i.image_path);
        // add "/1" to image_path to load the in size 1 (because it is only shown in a sidebar)
        const itemgroupImages = me._sotService.GetAllItemGroups().filter(g => g.has_image).map(g => g.image_path + "/1");
        me.images = [...advertisementImages, ...startPageMedia, costumLogoImages, paymentLogoImages, ...productImages, ...itemgroupImages];
        me.PushChanges();
      }
    })
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._sotService.coreLogService.error("MenuComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }
}